module.exports = __webpack_public_path__ + "static/media/8.74f56cb6.jpg";